const GET_MERCHANT_INFO = "GET_MERCHANT_INFO";
const GET_MERCHANT_INFO_SUCCESS = "GET_MERCHANT_INFO_SUCCESS";
const GET_MERCHANT_INFO_FAILURE = "GET_MERCHANT_INFO_FAILURE";
const CLEAR_GET_MERCHANT_INFO = "CLEAR_GET_MERCHANT_INFO";
const GetMerchantInfoSymbols = {
  GET_MERCHANT_INFO_SUCCESS,
  GET_MERCHANT_INFO_FAILURE,
  GET_MERCHANT_INFO,
  CLEAR_GET_MERCHANT_INFO,
};
export default GetMerchantInfoSymbols;
